import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Pagination from '~components/atoms/Pagination';

const SerialNumberSearchTablePaginator = () => {
    const isLoading = useAppSelector(state => state.gold.loadings.getSerialNumberListing);
    const { index, maxIndex } = useAppSelector(state => state.gold.serialNumber.serialNumberListing);

    const dispatch = useAppDispatch();

    const lastIndex = Math.max(maxIndex - 1, 0);

    const setIndex = (newIndex: number) => {
        if (isLoading) return;

        dispatch(combinedActions.goldSetSerialNumberListingIndex({ index: newIndex }));
    };

    useEffect(() => {
        if (index > lastIndex) {
            setIndex(0);
        }
    }, [lastIndex]);

    const handleOnPrev = () => {
        if (index > 0) setIndex(index - 1);
    };

    const handleOnNext = () => {
        if (index < lastIndex) setIndex(index + 1);
    };

    const handleOnFirst = () => setIndex(0);

    const handleOnLast = () => setIndex(lastIndex);

    return (
        <Pagination
            currentPage={index}
            maxPage={lastIndex}
            onPrev={handleOnPrev}
            onNext={handleOnNext}
            onFirst={handleOnFirst}
            onLast={handleOnLast}
        />
    );
};

export default SerialNumberSearchTablePaginator;
